.brandLogo {
  overflow: hidden;
  border: 1px solid rgb(0 0 0 / 5%);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: var(--colors-grays-white);
}

.brandLogo__smHeight {
  height: 48px;
  width: 48px;
}

.brandLogo__mdHeight {
  height: 48px;
  width: 48px;
}

.brandLogoImage {
  height: 48px;
  width: 48px;
  border-radius: 50%;
}

.brandLogoImage__mdHeight {
  height: 48px;
  width: 48px;
  border-radius: 50%;
}

@media all and (--reefer-media-tablet-min) {
  .brandLogo__mdHeight {
    height: 56px;
    width: 56px;
  }

  .brandLogoImage__mdHeight {
    height: 56px;
    width: 56px;
  }
}
